export default __webpack_public_path__ + "static/php_service_banner-768b8588e7dffaf292240637ee645a37.svg";